import { render, staticRenderFns } from "./MainUsersSetting.vue?vue&type=template&id=031c68fb"
import script from "./MainUsersSetting.vue?vue&type=script&lang=js"
export * from "./MainUsersSetting.vue?vue&type=script&lang=js"
import style0 from "./MainUsersSetting.vue?vue&type=style&index=0&id=031c68fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDataTable,VSheet,VSkeletonLoader})
